export default "__VITE_ASSET__B9PVTQR2__"